import React from 'react';
import {FormattedMessage} from 'react-intl';
import SurveyEditorItem from './SurveyEditorItem';

const SurveyEditorSection = ({name, title, children}) => (
    <SurveyEditorItem name={name} header={
        <div className="page-header d-flex flex-column justify-content-center">
            <FormattedMessage {...title} />
        </div>}>
        {children}
    </SurveyEditorItem>
);

export default SurveyEditorSection;
